'use client'

import {
  getCookieAccessToken,
  getCookieAuthUser
} from '../../../auth/services/token-service'
import { rolesByAuthUser } from '../../../auth/utils/roles'
import { MACROBOLSA_ROLE } from '../../../auth/constants/roles.constants'
import type { MacrobolsaUser } from './macrobolsa-user.interface'

export function getMacrobolsaUser(): MacrobolsaUser {
  const authUser = getCookieAuthUser()
  const cookieAccessToken = getCookieAccessToken()
  const auth0Roles = cookieAccessToken?.decodeAccessToken?.auth0Roles || []

  const isMacrobolsaUser = auth0Roles?.includes(MACROBOLSA_ROLE)
  const roles = authUser ? rolesByAuthUser(authUser) : { isAdvance: false }
  const isAdvance = roles?.isAdvance

  const hasMacrobolsaUser = Boolean(isMacrobolsaUser)
  const hasMacrobolsaNotAdvancedUser = Boolean(hasMacrobolsaUser && !isAdvance)

  return {
    hasMacrobolsaUser,
    hasMacrobolsaNotAdvancedUser,
    isAdvance
  }
}
